//Function to generate slug for created or edited lessons
const generateSlug = str => {
  str = str.replace(/^\s+|\s+$/g, ""); // trim
  str = str.toLowerCase();

  // remove accents, swap ñ for n, etc
  let from = "àáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
  let to = "aaaaaeeeeiiiioooouuuunc------";

  for (let i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
  }

  str = str
    .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
    .replace(/\s+/g, "-") // collapse whitespace and replace by -
    .replace(/-+/g, "-"); // collapse dashes

  return str;
};

// export default generateSlug;

const findVideo = (id, sections) => {
  let videoFound;

  sections.forEach((section, iSection) => {
    section.videos.forEach((video, iVideo) => {
      if (video.id === id) {
        videoFound = sections[iSection].videos[iVideo];
      }
    });
  });

  return videoFound;
};

const findIndexSectionWithId = (id, sections) => {
  let indexSection;

  sections.forEach((section, iSection) => {
    if (section && section.id === id) {
      indexSection = iSection;
    }
  });

  return indexSection;
};

const findIndexesWithLessonId = (id, sections) => {
  let indexSection;
  let indexLesson;
  sections.forEach((section, iSection) => {
    section.lessons.forEach((lesson, iLesson) => {
      if (lesson.id === id) {
        indexSection = iSection;
        indexLesson = iLesson;
      }
    });
  });

  return { indexSection, indexLesson };
};

export {
  findVideo,
  findIndexSectionWithId,
  findIndexesWithLessonId,
  generateSlug
};
